// import logo from './logo.svg';
import "./App.css";
import Cursor from "./components/cursor/Cursor";
import GitHubProfile from "./components/github-profile/GitHubProfile";
import Home from "./components/home/Home";
import { Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/navbar/Navbar";
import Footer from "./components/footer/Footer";
import { NotFound } from "./components/404";
import Resources from "./components/resources/Resources";
function App() {
  const location = useLocation();

  return (
    <>
      {location.pathname === "/" ? (
        <Home />
      ) : (
        <>
          <Navbar />
          <div id="app-container">
            <Routes>
              <Route path="/github-profile" element={<GitHubProfile />} />
              <Route path="/resources" element={<Resources />} />
              {/* Catch-all route for 404 */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
          <Footer />
        </>
      )}
      <Cursor />
    </>
  );
}

export default App;
